import { render } from "./PersonComponent.vue?vue&type=template&id=41d840d0&scoped=true"
import script from "./PersonComponent.vue?vue&type=script&lang=js"
export * from "./PersonComponent.vue?vue&type=script&lang=js"

import "./PersonComponent.vue?vue&type=style&index=0&id=41d840d0&scoped=true&lang=css"

import exportComponent from "/home/roland/coding/Kitchen101/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d840d0"]])

export default __exports__